import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input } from '@angular/core';
import { provideHlmIconConfig } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-autocomplete-search',
  template: ` <ng-content /> `,
  host: {
    '[class]': '_computedClass()',
    '(click)': '_focusInput()',
    '(focusin)': '_onFocusIn()',
    '(focusout)': '_onFocusOut()',
  },
  providers: [provideHlmIconConfig({ size: 'sm' })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HlmAutocompleteSearch {
  private readonly _elementRef = inject(ElementRef<HTMLElement>);

  /** The user defined class  */
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  /** The styles to apply  */
  protected readonly _computedClass = computed(() =>
    hlm(
      'shadow-xs flex h-9 min-w-0 items-center gap-2 rounded-md border cursor-text [&>_ng-icon]:flex-none [&>_ng-icon]:opacity-50',
      this.userClass(),
    ),
  );

  protected _focusInput(): void {
    this._elementRef.nativeElement.querySelector('input')?.focus();
  }

  protected _onFocusIn(): void {
    this._elementRef.nativeElement.classList.add('focus');
  }

  protected _onFocusOut(): void {
    this._elementRef.nativeElement.classList.remove('focus');
  }
}
